import {Divider, Space, Row} from "antd";
import ColorControls from "./ColorControls";
import Slide from "../../../Components/Slide";
import React from "react";
import DateRange from "../../../Components/DateRange";
import {Button} from "@mui/material";


const AllocationSider = ({validRange, dateRange, handleDateRangeChange, handleSkipIntervalChange, colorConfig,
                         setColorConfig, barPadding, setBarPadding, barOpacity, setBarOpacity, rollColors})=>{


    const handleDateChange = (startDate, endDate) => {
        console.log("Start Date: ", startDate, "End Date: ", endDate)
        handleDateRangeChange?.(startDate, endDate);

    };
    console.log('Valid Range: ', validRange, 'Date Range: ', dateRange)
    return (
        <Space direction={'vertical'}>
            <div className={'label-title'}>Select Date Range</div>
            <DateRange
                        onDateRangeChange={handleDateChange}
                        startDate={dateRange.startDate}
                        endDate={dateRange.endDate}
                        minDate={validRange.startDate}
                        maxDate={validRange.endDate}
                        dateFormat={'YYYY-MM-DD'}
                        allowClear={true}
            />
            <Divider />
            <div className={'label-title'}>Color Controls</div>
            <ColorControls
                active={colorConfig.luminosity}
                onChange={(value)=>setColorConfig({...colorConfig, luminosity: value})}
                onColorChange={rollColors}
            />
            <Button onClick={rollColors}>Roll New Colors</Button>
            <Divider/>

            <div className={'label-title'}>Bar Padding</div>
            <Slide
                onChange={(value)=>setBarPadding(value/100||0)}
                value={barPadding*100||0}
                width={200}
                fontColor={'#fff'}
                iconColor={'#aaccff'}
            />
            <div className={'label-title'}>Bar Opacity</div>
            <Slide
                onChange={(value)=>setBarOpacity(value/100||0)}
                value={barOpacity*100||0}
                width={200}
                fontColor={'#fff'}

            />
        </Space>

    )
}

export default AllocationSider;